import { connectHostname } from "./private/components/config";
import { isWindowedCcp } from "./private/configuration";

declare global {
  interface Window {
    CONNECT_CLIENT_BASE_URL?: string;
  }
}

// When it is a CCP popup, set the base URL for the custom CCP
// Otherwise, Omnia will set the base URL.
// This is to load the custom CPP MFE.
if (isWindowedCcp()) {
  window.CONNECT_CLIENT_BASE_URL = `https://${connectHostname()}`;
}
